// Building completion status per PRD §5.1.4 and §6.2.
// Transitions: NOT_STARTED → IN_PROGRESS (auto on first capture_session open)
// → COMPLETE (manual toggle by field staff when all rooms are captured).
//
// TO_BE_DEMOLISHED and OUT_OF_SCOPE are admin-only statuses: automatic
// session-driven recomputation (session create/complete/cancel/reopen,
// room delete, count update) must NEVER move a building into or out of
// them — only the admin building update endpoint sets/clears them, and
// field capture building lists hide buildings carrying them.

import { buildingStatusEnum } from '../db/schema'

export const BUILDING_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  TO_BE_DEMOLISHED: 'to_be_demolished',
  OUT_OF_SCOPE: 'out_of_scope',
} as const satisfies Record<
  string,
  'not_started' | 'in_progress' | 'complete' | 'to_be_demolished' | 'out_of_scope'
>

export type BuildingStatus =
  | 'not_started'
  | 'in_progress'
  | 'complete'
  | 'to_be_demolished'
  | 'out_of_scope'

export const BUILDING_STATUS_VALUES = buildingStatusEnum.enumValues

// The admin-only subset of BuildingStatus. Used as the freeze predicate in
// every automatic status write (guarded WHERE clauses) and as the hide
// filter for field-facing building lists.
export const ADMIN_ONLY_BUILDING_STATUSES = [
  'to_be_demolished',
  'out_of_scope',
] as const satisfies readonly BuildingStatus[]

export function isAdminOnlyBuildingStatus(status: BuildingStatus): boolean {
  return (ADMIN_ONLY_BUILDING_STATUSES as readonly BuildingStatus[]).includes(
    status,
  )
}
